<template>
	<div class="two-column-banner">
		<div class="mobile-mode">
			<div class="col-12 py-2">
				<a v-if="config.first_mobile_image_url" :href="config.first_url"><img :src="config.first_mobile_image_url" class="d-block w-100" alt="slide"></a>
				<a v-else :href="config.first_url"><img :src="config.first_image_url" class="d-block w-100" alt="slide"></a>
			</div>
			<div class="col-12 py-2">
				<a v-if="config.second_mobile_image_url" :href="config.second_url"><img :src="config.second_mobile_image_url" class="d-block w-100" alt="slide"></a>
				<a v-else :href="config.second_url"><img :src="config.second_image_url" class="d-block w-100" alt="slide"></a>
			</div>
		</div>
		<div class="desktop-mode">
			<div class="row">
				<div class="col-12 col-lg-6">
					<a :href="config.first_url"><img :src="config.first_image_url" class="d-block w-100" alt="slide"></a>
				</div>
				<div class="col-12 col-lg-6">
					<a :href="config.second_url"><img :src="config.second_image_url" class="d-block w-100" alt="slide"></a>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
export default {
	name: 'Banner',
	props: {
		config: {
			type: Object,
			default: null,
		},
	},
	data() {
		return {
		};
	},
};
</script>
<style lang="scss" scoped>
	.two-column-banner {
		img {
			border-radius: 5px;
		}
	}
	.desktop-mode {
		display: block;
	}

	@media only screen and (max-width: 767px) {
		.desktop-mode {
			display: none;
		}
	}
	@media only screen and (min-width: 768px) {
		.mobile-mode {
			display: none;
		}
	}
</style>
